(function(){
  'use strict';

  function ready(fn){
    if(document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function(){
    initProductGallery();
    initFaqEnhancements();
  });

  function initProductGallery(){
    var galleries = document.querySelectorAll('[data-product-gallery]');
    if(!galleries.length) return;

    galleries.forEach(function(gallery){
      var mainImage = gallery.querySelector('[data-main-image]');
      var mainButton = gallery.querySelector('[data-open-lightbox]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      var slides = Array.prototype.map.call(thumbs, function(btn){
        return {
          src: btn.getAttribute('data-full-src') || btn.getAttribute('data-src'),
          alt: btn.getAttribute('data-alt') || ''
        };
      });
      var currentIndex = 0;

      function setImage(index){
        if(!slides[index] || !mainImage) return;
        currentIndex = index;
        mainImage.src = slides[index].src;
        mainImage.alt = slides[index].alt;
        thumbs.forEach(function(t){ t.classList.remove('is-active'); });
        if(thumbs[index]) thumbs[index].classList.add('is-active');
      }

      thumbs.forEach(function(btn, index){
        btn.addEventListener('click', function(){ setImage(index); });
      });

      if(mainButton){
        mainButton.addEventListener('click', function(){
          openLightbox(slides, currentIndex);
        });
      }

      // Mobile swipe on main image
      var startX = 0;
      var endX = 0;
      if(mainButton){
        mainButton.addEventListener('touchstart', function(e){ startX = e.changedTouches[0].clientX; }, {passive:true});
        mainButton.addEventListener('touchend', function(e){
          endX = e.changedTouches[0].clientX;
          var delta = endX - startX;
          if(Math.abs(delta) > 45){
            if(delta < 0 && currentIndex < slides.length - 1) setImage(currentIndex + 1);
            if(delta > 0 && currentIndex > 0) setImage(currentIndex - 1);
          }
        }, {passive:true});
      }
    });
  }

  function openLightbox(slides, index){
    if(!slides.length) return;
    var current = index || 0;
    var overlay = document.createElement('div');
    overlay.className = 'gp-lightbox';
    overlay.innerHTML = ''+
      '<button class="gp-lightbox__close" aria-label="Cerrar">×</button>'+
      '<button class="gp-lightbox__nav gp-lightbox__prev" aria-label="Imagen anterior">‹</button>'+
      '<div class="gp-lightbox__stage"><img class="gp-lightbox__img" alt=""></div>'+
      '<button class="gp-lightbox__nav gp-lightbox__next" aria-label="Imagen siguiente">›</button>'+
      '<div class="gp-lightbox__hint">Clic o doble tap para acercar · Pinch zoom en móvil</div>';
    document.body.appendChild(overlay);
    document.body.classList.add('gp-lightbox-open');

    var img = overlay.querySelector('.gp-lightbox__img');
    var stage = overlay.querySelector('.gp-lightbox__stage');
    var zoomed = false;

    function render(){
      img.src = slides[current].src;
      img.alt = slides[current].alt || 'Imagen Gummipads';
      zoomed = false;
      img.classList.remove('is-zoomed');
    }
    function close(){
      document.body.classList.remove('gp-lightbox-open');
      overlay.remove();
    }
    function prev(){ current = (current - 1 + slides.length) % slides.length; render(); }
    function next(){ current = (current + 1) % slides.length; render(); }

    overlay.querySelector('.gp-lightbox__close').addEventListener('click', close);
    overlay.querySelector('.gp-lightbox__prev').addEventListener('click', prev);
    overlay.querySelector('.gp-lightbox__next').addEventListener('click', next);
    overlay.addEventListener('click', function(e){ if(e.target === overlay) close(); });
    stage.addEventListener('click', function(){
      zoomed = !zoomed;
      img.classList.toggle('is-zoomed', zoomed);
    });
    document.addEventListener('keydown', function keyHandler(e){
      if(!document.body.contains(overlay)){ document.removeEventListener('keydown', keyHandler); return; }
      if(e.key === 'Escape') close();
      if(e.key === 'ArrowLeft') prev();
      if(e.key === 'ArrowRight') next();
    });

    var sx = 0;
    stage.addEventListener('touchstart', function(e){ sx = e.changedTouches[0].clientX; }, {passive:true});
    stage.addEventListener('touchend', function(e){
      var dx = e.changedTouches[0].clientX - sx;
      if(Math.abs(dx) > 45){ dx < 0 ? next() : prev(); }
    }, {passive:true});

    render();
  }

  function initFaqEnhancements(){
    document.querySelectorAll('.faq details').forEach(function(item){
      item.addEventListener('toggle', function(){
        if(item.open){
          document.querySelectorAll('.faq details').forEach(function(other){
            if(other !== item) other.open = false;
          });
        }
      });
    });
  }
})();
